import React from 'react';
import { array, string, shape } from 'prop-types';

import { baseSpacing, colors } from 'css/constants';

import styled from 'styled-components/macro';

const CreditDetailsPrimitive = styled.div`
  margin: ${baseSpacing / 2}px 0 0 ${baseSpacing / 3}px;

  ul {
    margin: 0 0 1rem;
    padding: 0;
    font-size: 0.96rem;
  }

  li {
    list-style-type: none;
    margin-left: 0;
  }

  li::before {
    content: '\u2714';
    margin: 0 4px 0 0;
    color: ${colors.lightBlue};
  }

  .header {
    margin: 0;
    font-weight: bold;
    color: ${colors.darkerGrey};
  }
`;

const CreditDetails = ({ sku }) => {
  const footer = <div>All unused credits expire after 12 months.</div>;
  if (!sku) {
    return <CreditDetailsPrimitive>{footer}</CreditDetailsPrimitive>;
  }
  const { name } = sku;
  const { details } = sku.meta || {};
  return (
    <CreditDetailsPrimitive>
      <div className="header">{name}</div>
      {details ? (
        <ul>
          {details.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      ) : (
        ''
      )}
      {footer}
    </CreditDetailsPrimitive>
  );
};

CreditDetails.propTypes = {
  sku: shape({
    meta: shape({
      details: array
    }),
    name: string.isRequired
  })
};

export default CreditDetails;
